import { useState } from 'react';

import { PartnerKitStepProps, InformationView } from '../types';
import { Typography } from 'components';

import { SampleDateScreen } from './InformationScreens/SampleDateScreen';
import { MemberInfoScreen } from './InformationScreens/MemberInfoScreen';
import { FemaleAdultScreen } from './InformationScreens/FemaleAdultScreen';
import { EmailScreen } from './InformationScreens/EmailScreen';

export const InformationStep = ({
  setActivationState,
  activationState,
  step,
  setCurrentActivationStep,
}: PartnerKitStepProps) => {
  const { kit } = activationState;
  const [screen, setScreen] = useState<InformationView>('sample_date');

  return (
    <>
      <Typography variant='heading-l' weight='medium' className='pb-2'>
        Tell us about yourself
      </Typography>
      <div className='flex flex-column gap-2'>
        <div className='mt-3'>
          <Typography variant='body-m'>{`Kit ID: ${kit.id}`}</Typography>
        </div>
        {screen === 'sample_date' && (
          <SampleDateScreen
            setScreen={setScreen}
            activationState={activationState}
            setActivationState={setActivationState}
          />
        )}
        {screen === 'female_adult' && (
          <FemaleAdultScreen
            setScreen={setScreen}
            activationState={activationState}
            setActivationState={setActivationState}
          />
        )}
        {screen === 'member_info' && (
          <MemberInfoScreen
            setScreen={setScreen}
            activationState={activationState}
            setActivationState={setActivationState}
          />
        )}
        {screen === 'email' && (
          <EmailScreen
            activationState={activationState}
            setActivationState={setActivationState}
            setScreen={setScreen}
            step={step}
            setCurrentActivationStep={setCurrentActivationStep}
          />
        )}
      </div>
    </>
  );
};
